// import { ChainAddress } from "@addresses";
import { abi, }  from ".";
import { Addresses, wagmiConfig,  } from "@config";
// import { getAccount as gg,  } from "wagmi/actions";
import { getAccount, } from "wagmi/actions";
import { getConnectionInfo, raise,  } from "@helpers";
import type { ExecutableToken, Address, ChainId, AnyToken, } from "@types";
import { lookupToken, lookupContract, TokenDefinition, } from "@bracket/addressbook";
import { getChainId, } from "../helpers";



/**
 * get the balance of a wallet for a given token.
 * 
 * @param {ExecutableToken} token 
 * @param {Address} wallet 
 * @returns {BigInt} the balance of the wallet for the argued token in WEI
 */
export const balanceOf = ( chain: ChainId ) => ( token: ExecutableToken, wallet: Address, ): any => {
	throw new Error("@bracket/contracts is deprecating balanceof, use balanceOfCore");
	// if( token in Addresses ) {
	// 	const props = {
	// 		address: ChainAddress(chain, token),
	// 		abi,
	// 		functionName: "balanceOf",
	// 		args: [ wallet ],
	// 	};
	// 	// console.log(`>>> BALANCEOF ${token} >>>`, props);
	// 	return props;
	// }
	throw new Error(`contracts::ERC20::balanceOf was provided an invalid executable token "${token}"`)
}

export const balanceOfCore = ({ token, log = false, }:{ token: TokenDefinition, log?:boolean, }): any => {
	const {
		address,
	} = getAccount(wagmiConfig);
	if( address ) {
		const contract = {
			address: token.address,
			abi,
			functionName: "balanceOf",
			args: [ address, ]
		};
		if( log )
			console.log("constracts::ERC20::balanceOfCore payload", contract);
		return contract;
	}
	throw new Error("wagmi failed to produce a valid address, restarting.");
};


/**
 * Get the allowance for a given smart contract
 * 
 * @param {Address} owner the owner of the asset, most likely the wallet address. 
 * @param {Address} spendingContract the contract address who will be spending this asset on behalf of the owner
 * @returns 
 */
export const allowance = ( chain: ChainId) => ( token: ExecutableToken, owner: Address, contract: Address, ): any => {
	if( token in Addresses ) {
		const address = lookupToken(chain, token as any); //ChainAddress(chain, token);
		const props = {
			address,
			abi,
			functionName: "allowance",
			args: [
				owner,				
				contract,
			]
		};
		return props;
	}
	throw new Error(`ERC20::allowance was provided an invalid executable token "${token}"`)
}

export const allowCore = ({
	token,
	chain,
	contract,
}: { token: TokenDefinition, chain?: ChainId, contract?: string; }) => {

	try {
		if( !contract )
			throw new Error("no contract provided");

		chain = chain || getChainId();

		const { address: walletAddress, connector, } = getAccount(wagmiConfig);
		const contractAddress = lookupContract(chain, contract as any) || raise(`unknown contract "${contract}"`)
		if( walletAddress ) {
			if( chain ) {
				const result = {
					address: token.address,
					abi,
					functionName: "allowance",
					args: [ walletAddress, contractAddress, ],
					dataSuffix: "0x",
					connector
				};

				const log = [
					"--- ALLOWANCE ---",
					`chain: ${chain}`,
					`currency: ${token.label}`,
					`called address: ${result.address}`,
					`functionName: ${result.functionName}`,
					`args:`,
					`\t0 [owner]: ${result.args[0]}`,
					`\t1 [spender]: ${result.args[1]}`,
					"----------",
				];
				// console.log(log.join("\n"));
				return result;

				// console.log("ALLOW CONTRACT ARGS", result);
				return result;
			}
			throw new Error(`wagmi failed to provide a valid chain id`);
		}
		throw new Error(`wagmi failed to produce a wallet address`);
	}
	catch( err ) {
		throw new Error(`ERC20::allowance core failed - ${err instanceof Error ? err.message : "not an error instance"}` );
	}

};


/**
 * Approve a smart contract to a limited amount of token by which to spend.
 * 
 * @param {Address} contract the contract address who will be approved to spend the argued amount of token;
 * @param {WEI} amount the amount of token the contract can spend on behalf of the user.
 * @returns 
 */
export const approve = (chain: ChainId) => ( token: ExecutableToken, ): any => {
	if( token in Addresses ) {
		const props = {
			address: lookupToken(chain, token as any), //ChainAddress(chain, token);
			abi,
			functionName: "approve",
		};
		return props;
	}
	throw new Error("ERC20::approve - unknown contract/spender address");
}

export const approveCore = ({
	token,
	amount,
	chain,
	contract,
}: { token: TokenDefinition, amount: bigint, chain?:ChainId, contract?: string; }) => {

	// console.log("approve --- ")

	const { address:wallet, connector, } = getAccount(wagmiConfig);
	chain = chain || getChainId();
	const address = lookupContract(chain, contract as any);

	// console.log(`approve --- chain ${chain}`)
	// console.log(`approve--- token "${token.symbol}"`);
	// console.log(`approve--- contract "${contract}" at address "${address}"`);
	// console.log(`approve--- amount "${amount}" ${typeof amount}`);
	const result = {
		address: token.address,
		abi,
		functionName: "approve",
		args: [ address.toLowerCase(), amount, ],
		account: wallet,
		// dataSuffix: "0x",
		connector
	};
	const log = [
		"--- APPROVE ---",
		`currency: ${token.label}`,
		`contract address: ${result.address}`,
		`functionName: ${result.functionName}`,
		"args:",
		`\t0 [recipient address]: ${result.args[0]}`,
		`\t1 [amount] ${result.args[1].toString()} (${Number(result.args[1]) / Number(1e18)}${token.label})`,
		"----------",
	];
	// console.log(log.join("\n"))
	return result;

};

